import React from "react";
import {useVideoConfig, interpolate} from "remotion";
import {Audio} from "@remotion/media";

export interface AudioTrackProps {
  src: string;
  volume?: number;
  fadeInDurationSeconds?: number;
  fadeOutDurationSeconds?: number;
  duckDuringSegments?: Array<{startSeconds: number; endSeconds: number}>;
  duckVolume?: number;
  loop?: boolean;
  trimStartSeconds?: number;
  trimEndSeconds?: number;
}

export const AudioTrack: React.FC<AudioTrackProps> = ({
  src,
  volume = 0.3,
  fadeInDurationSeconds = 1,
  fadeOutDurationSeconds = 2,
  duckDuringSegments,
  duckVolume = 0.1,
  loop = true,
  trimStartSeconds = 0,
  trimEndSeconds,
}) => {
  const {fps, durationInFrames} = useVideoConfig();

  const fadeInFrames = Math.round(fadeInDurationSeconds * fps);
  const fadeOutFrames = Math.round(fadeOutDurationSeconds * fps);
  const trimBefore = Math.round(trimStartSeconds * fps);
  const trimAfter = trimEndSeconds !== undefined
    ? Math.round(trimEndSeconds * fps)
    : undefined;

  const volumeCallback = (frame: number): number => {
    // Fade in
    let vol = volume;
    if (frame < fadeInFrames) {
      vol *= interpolate(frame, [0, fadeInFrames], [0, 1], {
        extrapolateRight: "clamp",
      });
    }

    // Fade out
    const fadeOutStart = durationInFrames - fadeOutFrames;
    if (frame >= fadeOutStart) {
      vol *= interpolate(frame, [fadeOutStart, durationInFrames], [1, 0], {
        extrapolateLeft: "clamp",
        extrapolateRight: "clamp",
      });
    }

    // Duck during speech segments
    if (duckDuringSegments) {
      const currentSeconds = frame / fps;
      const isDucking = duckDuringSegments.some(
        (seg) => currentSeconds >= seg.startSeconds && currentSeconds <= seg.endSeconds,
      );
      if (isDucking) {
        vol = duckVolume;
      }
    }

    return vol;
  };

  return (
    <Audio
      src={src}
      volume={volumeCallback}
      loop={loop}
      trimBefore={trimBefore}
      trimAfter={trimAfter}
    />
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
